<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-3" icon="fa fa-cube" titulo="CADASTRO DE PRODUTO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap w-100">
            <div class="d-flex align-items-center mr-4">
              <span class="mr-2">
                <i class="fa fa-barcode mr-1 text-info"></i>
                CÓDIGO: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
              </span>
              <span v-if="registro.DESCRICAO" class="mx-2 opacity-50">•</span>
              <span v-if="registro.DESCRICAO" class="mr-2">
                <i class="fa fa-tag mr-1 text-info"></i>
                {{registro.DESCRICAO.substring(0,30)}}
              </span>
            </div>
            
            <div class="d-flex align-items-center">
              <b-badge :variant="registro.OP_SITUACAO === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2 border border-white-50">
                {{registro.OP_SITUACAO === '1' ? 'ATIVO' : 'INATIVO'}}
              </b-badge>
              
              <b-badge v-if="registro.OP_PERMITE_VENDA === '1'" variant="info" pill class="px-3 py-1 shadow-sm mr-2 border border-white-50">
                VENDA ATIVA
              </b-badge>

              <b-badge variant="light" pill class="px-3 py-1 shadow-sm text-dark font-weight-bold">
                {{ registro.UND_SAI || 'UND' }}
              </b-badge>
            </div>

            <!-- Stats Compactas no Header -->
            <div class="ml-auto d-none d-xl-flex align-items-center bg-black-25 rounded-pill px-3 py-1 border border-white-10">
              <div class="text-center px-3 border-right border-white-10">
                <small class="d-block text-uppercase font-weight-bold text-white-50" style="font-size: 0.6rem;">Preço Venda</small>
                <span class="text-white font-weight-bold" style="font-size: 0.9rem;">{{ registro.VL_VENDA ? registro.VL_VENDA.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00' }}</span>
              </div>
              <div class="text-center px-3 border-right border-white-10">
                <small class="d-block text-uppercase font-weight-bold text-white-50" style="font-size: 0.6rem;">Estoque</small>
                <span class="text-white font-weight-bold" style="font-size: 0.9rem;">{{ registro.SALDO_FI ? registro.SALDO_FI.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : '0,000' }}</span>
              </div>
              <div class="text-center pl-3">
                <small class="d-block text-uppercase font-weight-bold text-white-50" style="font-size: 0.6rem;">Margem</small>
                <span class="text-success font-weight-bold" style="font-size: 0.9rem;">{{ registro.MARGEM ? registro.MARGEM.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : '0,00' }}%</span>
              </div>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold shadow-sm" @click.stop.prevent="postOrEdit()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <b-row class="px-2">
        <b-card-group deck class="ml-1 mr-1">
          
            
              <!-- Identificação -->
              <b-card style="flex: 0 0 70%;" class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
                <div class="bg-light p-3 border-bottom d-flex align-items-center">
                  <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                    <i class="fa fa-id-card"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 font-weight-bold text-dark">Identificação e Dados Básicos</h6>
                    <small class="text-muted">Informações essenciais do produto</small>
                  </div>
                </div>
                
                <div class="p-4">
                  <b-row>
                    <b-col sm="2">
                      <label class="modal-label-premium">Código</label>
                      <b-form-input type="text" id="ID" :disabled="true" class="rounded-pill bg-gray-100 border-0 font-weight-bold text-center" placeholder="Auto" v-model="registro.CODIGO"></b-form-input>
                    </b-col>
                    <b-col sm="4">
                      <label class="modal-label-premium">EAN 13 (Código de Barras)</label>
                      <b-form-input type="text" id="edEAN" class="rounded-pill shadow-xs" placeholder="Gtin / Ean" v-model="registro.EAN" maxlength="13"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <label class="modal-label-premium">NCM</label>
                      <b-form-input type="text" id="edTX_NCM" ref="edTX_NCM" class="rounded-pill shadow-xs" placeholder="Nomenclatura Comum" v-model="registro.TX_NCM" :state="!!registro.TX_NCM" maxlength="8"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <label class="modal-label-premium">CEST</label>
                      <b-form-input type="text" id="edCES" class="rounded-pill shadow-xs" placeholder="Subst. Tributária" v-model="registro.CEST" maxlength="7"></b-form-input>
                    </b-col>
                  </b-row> 

                  <b-row class="mt-3">
                    <b-col sm="8">
                      <label class="modal-label-premium">Descrição Completa</label>
                      <b-form-input type="text" id="edDESCRICAO" ref="edDESCRICAO" class="rounded-pill shadow-xs font-weight-bold"
                        placeholder="Nome principal do produto"
                        v-model="registro.DESCRICAO"
                        :state="!!registro.DESCRICAO" maxlength="100"> </b-form-input>
                    </b-col>  
                    <b-col sm="4">
                      <label class="modal-label-premium">Nome Reduzido</label>
                      <b-form-input type="text" id="edREZUMIDO" ref="edREZUMIDO" class="rounded-pill shadow-xs"
                        placeholder="Para cupons e etiquetas" 
                        v-model="registro.REZUMIDO"
                        :state="!!registro.REZUMIDO" maxlength="50"> </b-form-input>
                    </b-col>  
                  </b-row>  

                  <b-row class="mt-3">
                    <b-col sm="6">
                      <label class="modal-label-premium">Fornecedor Preferencial</label>
                      <cliente-pesquisa 
                        @retornaId="registro.COD_FOR = $event"
                        :idInicial="registro.COD_FOR"
                        :classeRequired="true"
                        :desabilitarInput="false"
                        id-modal="modalCliente"
                        id="edCOD_FOR"
                        ref="edCOD_FOR"
                        :arredondado="true"
                        place="Pesquise o fornecedor..."
                        labelBotao="">
                      </cliente-pesquisa>
                    </b-col>
                    <b-col sm="6">
                      <label class="modal-label-premium">Grupo de Produto</label>
                      <GrupoProdutoDropDown v-model="registro.COD_GRUP" input-class="rounded-pill" />
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            
          
        
         
            <!-- Marcadores -->
            <b-card class="border-0 shadow-sm mb-4 overflow-hidden" body-class="p-0">
              <div class="bg-light p-3 border-bottom d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-toggle-on"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">Status e Configurações</h6>
                  <small class="text-muted">Controles de comportamento</small>
                </div>
              </div>

              <div class="p-4">
                <div class="bg-gray-100 rounded p-3 mb-3">
                  <b-row>
                    <b-col sm="6" class="mb-2">
                      <b-form-checkbox v-model="registro.OP_SITUACAO" value="1" unchecked-value="0" switch class="custom-switch-lg font-weight-bold">
                        Ativo
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="6" class="mb-2">
                      <b-form-checkbox v-model="registro.OP_PERMITE_VENDA" value="1" unchecked-value="0" switch class="custom-switch-lg font-weight-bold">
                        Venda
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </div>

                <b-row>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_BENEFICIA" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Beneficia
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_BENEFICIADO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Beneficiado
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_GRADE" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Grade
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_ANIMAL" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Animal
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_MOSTRAR_APP" value="1" unchecked-value="0" switch class="custom-switch-md">
                      App
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_MATERIA_PRIMA" value="1" unchecked-value="0" switch class="custom-switch-md">
                        Matéria-Prima
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="4" class="mb-2">
                      <b-form-checkbox v-model="registro.OP_CONTROLA_LOTE" value="1" unchecked-value="0" switch class="custom-switch-md">
                        Controla Lote
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="4" class="mb-2">
                      <b-form-checkbox v-model="registro.OP_USA_FORMULA" value="1" unchecked-value="0" switch class="custom-switch-md">
                        Usa Fórmula
                      </b-form-checkbox>
                    </b-col>
                    <b-col sm="4" class="mb-2">
                      <b-form-checkbox v-model="registro.OP_GERA_LOTE_PRODUCAO" value="1" unchecked-value="0" switch class="custom-switch-md">
                        Gera Lote Produção
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_QUARTO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Quarto
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_BANDA" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Banda
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_PESADO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Pesado
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_PESO_FIXO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Peso Fixo
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_CONFIRMAR_PECAS_EXPEDICAO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Confirmar Peças
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="4" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_CONTROLA_PECAS" value="S" unchecked-value="N" switch class="custom-switch-md">
                      Controla Peças
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <hr class="my-3">

                <b-row>
                  <b-col sm="6" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_PRODUTO_PRODUCAO" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Estoque da Produção
                    </b-form-checkbox>
                  </b-col>
                  
                  <b-col sm="6" class="mb-2">
                    <b-form-checkbox v-model="registro.OP_ESTOQUE" value="1" unchecked-value="0" switch class="custom-switch-md">
                      Controla Estoque
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          
          </b-card-group>
      </b-row>

      <div class="px-2">
        <b-card no-body class="border-0 shadow-sm">
          <b-tabs card active-nav-item-class="font-weight-bold text-primary" nav-class="bg-light border-bottom-0">
            <b-tab active>
              <template #title>
                <i class='fa fa-list-alt mr-1'></i><strong> Estocagem</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="2">
                  <label class="modal-label-premium">UND Comercializada</label>
                  <b-form-select 
                      v-model="registro.ID_UNIDADE_COMERCIAL" 
                      ref="comboID_UNIDADE_COMERCIAL"
                      class="rounded-pill"
                      :options="optionsID_UNIDADE_COMERCIAL"  
                      :state="!!registro.ID_UNIDADE_COMERCIAL"
                      >
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Quant. Embalagem</label>
                  <vue-autonumeric  v-model="registro.QT_EMBALAGEM" 
                                      ref="edQT_EMBALAGEM"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.QT_EMBALAGEM,
                                          'is-invalid' : !registro.QT_EMBALAGEM
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Estq. Min</label>
                  <vue-autonumeric  v-model="registro.EST_MIN" 
                                      ref="edEST_MIN"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.EST_MIN,
                                          'is-invalid' : !registro.EST_MIN
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Estq. Máx</label>
                  <vue-autonumeric  v-model="registro.EST_MAX" 
                                      ref="edEST_MAX"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.EST_MAX,
                                          'is-invalid' : !registro.EST_MAX
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Peso Bruto</label>
                  <vue-autonumeric  v-model="registro.PESO" 
                                      ref="edPESO"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.PESO,
                                          'is-invalid' : !registro.PESO
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Peso Líquido</label>
                  <vue-autonumeric  v-model="registro.PESO_LIQUIDO" 
                                      ref="edPESO_LIQUIDO"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.PESO_LIQUIDO,
                                          'is-invalid' : !registro.PESO_LIQUIDO
                                        }]">
                    </vue-autonumeric>
                </b-col>
              </b-row> 
              <b-row class="mt-3">
                <b-col sm="2">
                  <label class="modal-label-premium">Tara Embalagem</label>
                  <vue-autonumeric  v-model="registro.TARA_EMBALAGEM" 
                                      ref="edTARA_EMBALAGEM"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.TARA_EMBALAGEM,
                                          'is-invalid' : !registro.TARA_EMBALAGEM
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Dias validade</label>
                  <vue-autonumeric  v-model="registro.VALIDADE" 
                                      ref="edVALIDADE"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.VALIDADE,
                                          'is-invalid' : !registro.VALIDADE
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Armazenamento</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_TIPO_ESTOCAGEM" 
                        class="rounded-pill"
                        :state="!!registro.OP_TIPO_ESTOCAGEM"
                        :options="optionsOP_TIPO_ESTOCAGEM">
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Mensagem Armazenamento</label>
                  <b-form-input type="text" id="edMENSAGEM_ARMAZENAMENTO" class="rounded-pill" placeholder="" v-model="registro.MENSAGEM_ARMAZENAMENTO" maxlength="100"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Mensagem Conservação</label>
                  <b-form-input type="text" id="edMENSAGEM_CONSERVACAO" class="rounded-pill" placeholder="" v-model="registro.MENSAGEM_CONSERVACAO" maxlength="100"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="2">
                  <label class="modal-label-premium">Temp. Mínima</label>
                  <vue-autonumeric  v-model="registro.TEMPERATURA_MINIMA" 
                                      ref="edTEMPERATURA_MINIMA"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.TEMPERATURA_MINIMA,
                                          'is-invalid' : !registro.TEMPERATURA_MINIMA
                                        }]">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Temp. Máxima</label>
                  <vue-autonumeric  v-model="registro.TEMPERATURA_MAXIMA" 
                                      ref="edTEMPERATURA_MAXIMA"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control rounded-pill', {
                                          'is-valid' : registro.TEMPERATURA_MAXIMA,
                                          'is-invalid' : !registro.TEMPERATURA_MAXIMA
                                        }]">
                    </vue-autonumeric>
                </b-col>
              </b-row>
            </b-tab>
            
            <b-tab>
              <template #title>
                <i class='fa fa-inbox mr-1'></i><strong> Embalagem</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="2">
                  <label class="modal-label-premium">Formato</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.FORMATO_EMBALAGEM_ID" 
                        class="rounded-pill"
                        :options="optionsFORMATO_EMBALAGEM_ID">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Capacidade</label>
                  <vue-autonumeric  v-model="registro.CAPACIDADE" 
                                      ref="edCAPACIDADE"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maximumValue: 1000
                                        }"
                                        class="form-control rounded-pill">
                    </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Unidade</label>
                  <b-form-select 
                      v-model="registro.UNIDADE_COMERCIAL_CAPACIDADE_ID" 
                      class="rounded-pill"
                      :options="optionsID_UNIDADE_COMERCIAL"  
                      >
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Cor</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.COR_ID" 
                        class="rounded-pill"
                        :options="optionsCOR_ID">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Material</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.MATERIAL_ID" 
                        class="rounded-pill"
                        :options="optionsMATERIAL_ID">
                  </b-form-select>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class='fa fa-barcode mr-1'></i><strong> Terminais de Etiquetas</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="4">
                  <label class="modal-label-premium">Expedição</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_EXPEDICAO_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Saída Desossa Encaixot</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_DESOSSA_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Interna</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_INTERNA_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="4">
                  <label class="modal-label-premium">Resumo Miúdo</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_RESUMO_ABATE_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Beneficiamento</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_BENEFICIAMENTO_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Recepçao de Mercadoria</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.ETIQUETA_RECEPCAO_ID" 
                        class="rounded-pill"
                        :options="optionsETIQUETAS">
                  </b-form-select>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class='fa fa-coffee mr-1'></i><strong> Dados Nutricionais</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="12">
                  <div class="table-responsive">
                    <table class="table table-sm table-borderless">
                      <thead>
                        <tr>
                          <th style="width: 200px"></th>
                          <th class="text-center bg-light rounded-left">Porção 1</th>
                          <th class="text-center bg-light">%</th>
                          <th class="text-center bg-light">Porção 2</th>
                          <th class="text-center bg-light rounded-right">%</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="modal-label-premium align-middle">Quantidade</td>
                          <td><b-form-input type="text" v-model="registro.QUANTIDADE_PORCAO" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.QUANTIDADE_PORCAO_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.QUANTIDADE_PORCAO2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.QUANTIDADE_PORCAO_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Valor Energetico</td>
                          <td><b-form-input type="text" v-model="registro.VALOR_ENERGETICO" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.VALOR_ENERGETICO_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.VALOR_ENERGETICO2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.VALOR_ENERGETICO_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Carboidratos</td>
                          <td><b-form-input type="text" v-model="registro.CARBOIDRATOS" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.CARBOIDRATOS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.CARBOIDRATOS2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.CARBOIDRATOS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Gorduras Trans</td>
                          <td><b-form-input type="text" v-model="registro.GORDURAS_TRANS" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.GORDURAS_TRANS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.GORDURAS_TRANS2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.GORDURAS_TRANS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Gorduras Totais</td>
                          <td><b-form-input type="text" v-model="registro.ACUCARES_TOTAIS" class="rounded-pill text-right" maxlength="10"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.ACUCARES_TOTAIS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.ACUCARES_TOTAIS2" class="rounded-pill text-right" maxlength="10"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.ACUCARES_TOTAIS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Cálcio</td>
                          <td><b-form-input type="text" v-model="registro.CALCIO" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.CALCIO_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.CALCIO2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.CALCIO_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Proteína</td>
                          <td><b-form-input type="text" v-model="registro.PROTEINAS" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.PROTEINAS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.PROTEINAS2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.PROTEINAS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Gorduras Saturadas</td>
                          <td><b-form-input type="text" v-model="registro.GORDURAS_SATURADAS" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.GORDURAS_SATURADAS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.GORDURAS_SATURADAS2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.GORDURAS_SATURADAS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Fibra Alimentar</td>
                          <td><b-form-input type="text" v-model="registro.FIBRA_ALIMENTAR" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.FIBRA_ALIMENTAR_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.FIBRA_ALIMENTAR2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.FIBRA_ALIMENTAR_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Colesterol</td>
                          <td><b-form-input type="text" v-model="registro.COLESTEROL" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.COLESTEROL_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.COLESTEROL2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.COLESTEROL_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Açucares Adicionados</td>
                          <td><b-form-input type="text" v-model="registro.ACUCARES_ADICIONADOS" class="rounded-pill text-right" maxlength="10"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.ACUCARES_ADICIONADOS_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.ACUCARES_ADICIONADOS2" class="rounded-pill text-right" maxlength="10"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.ACUCARES_ADICIONADOS_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Ferro</td>
                          <td><b-form-input type="text" v-model="registro.FERRO" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.FERRO_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.FERRO2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.FERRO_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                        <tr>
                          <td class="modal-label-premium align-middle">Sódio</td>
                          <td><b-form-input type="text" v-model="registro.SODIO" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.SODIO_PORCENTO" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                          <td><b-form-input type="text" v-model="registro.SODIO2" class="rounded-pill text-right" maxlength="30"></b-form-input></td>
                          <td><vue-autonumeric v-model="registro.SODIO_PORCENTO2" :options="formatoPercentual" class="form-control rounded-pill text-right"></vue-autonumeric></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="12">
                  <label class="modal-label-premium">Observações Nutricionais</label>
                  <b-form-input type="text" v-model="registro.OBSERVACOES_NUTRICIONAIS" class="rounded-pill" maxlength="30"></b-form-input>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class='fa fa-money mr-1'></i><strong> Preços e Custos</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="2">
                  <label class="modal-label-premium">Preço Venda</label>
                  <vue-autonumeric  v-model="registro.VL_VENDA" :options="formatoMoeda"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Preço Promocional</label>
                  <vue-autonumeric  v-model="registro.VL_VENDAPRO" :options="formatoMoeda"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Desconto Máximo %</label>
                  <vue-autonumeric  v-model="registro.VL_DESCONTO_PERCENTUAL" :options="formatoPercentual"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Desconto Máximo R$</label>
                  <vue-autonumeric  v-model="registro.VL_DESCONTO" :options="formatoMoeda"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Tipo de Desconto</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_TIPO_DESCONTO" 
                        class="rounded-pill"
                        :options="optionsOP_TIPO_DESCONTO">
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="2">
                  <label class="modal-label-premium">Custo Atual R$</label>
                  <vue-autonumeric  v-model="registro.VL_CUSTO" :options="formatoMoeda" :disabled="true" class="form-control rounded-pill bg-light text-right"> </vue-autonumeric>
                  <small class="text-muted">Use o botão consultar ou Atualizar o Custo.</small>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Ativar custo Manual</label>
                  <b-form-checkbox
                    id="cbOP_CUSTO_MANUAL-1"
                    v-model="registro.OP_CUSTO_MANUAL"
                    name="checkbox-cbOP_CUSTO_MANUAL"
                    value="1"
                    unchecked-value="0"
                    switch
                    class="custom-switch-lg">
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="12">
                    <b-button v-if="habilitaGruposFilhos == true"
                              ref="btabrirModalHistoricoCompras" 
                              variant="outline-primary"
                              pill
                              class="px-4 shadow-sm"
                              @click.stop.prevent="abrirModalHistoricoCompras()">
                        <i class="fa fa-eye mr-1"></i>  
                      Ultimas Compras
                    </b-button>
                    <b-button v-if="((habilitaGruposFilhos == true) && (registro.OP_CUSTO_MANUAL === '1'))"
                              class="ml-3 px-4 shadow-sm"
                              ref="btAtualizarCusto" 
                              variant="outline-info"
                              pill
                              @click.stop.prevent="abrirModalAtualizarCusto()">
                        <i class="fa fa-random mr-1"></i>      
                      Atualizar Custo Manualmente
                    </b-button>
                </b-col>
              </b-row>
            </b-tab>
            
            <b-tab>
              <template #title>
                <i class='fa fa-money mr-1'></i><strong> ICMS, PIS E COFINS</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="4">
                  <label class="modal-label-premium">ICMS Operação Estadual</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.TRIBUTACAO_ICMS_INTERNA_ID" 
                        class="rounded-pill"
                        :options="optionsTRIBUTACAO_ICMS_INTERNA_ID">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">ICMS Operação Interestadual</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.TRIBUTACAO_ICMS_EXTERNA_ID" 
                        class="rounded-pill"
                        :options="optionsTRIBUTACAO_ICMS_EXTERNA_ID">
                  </b-form-select>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">ICMS Operação Exterior</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.TRIBUTACAO_ICMS_EXTERIOR_ID" 
                        class="rounded-pill"
                        :options="optionsTRIBUTACAO_ICMS_EXTERIOR_ID">
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col sm="6">
                  <label class="modal-label-premium">PIS Situação Tributária</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_PIS_SITUACAO_TRIBUTARIA" 
                        class="rounded-pill"
                        :options="pis.opTipoSituacaoTributaria">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">PIS Tipo Cálculo</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_PIS_TIPO_CALCULO" 
                        class="rounded-pill"
                        :options="pis.opTipoCalculo">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Alíquota %</label>
                  <vue-autonumeric  v-model="registro.VL_PIS_ALIQUOTA_PERCENT" :options="formatoPercentual"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Alíquota R$</label>
                  <vue-autonumeric  v-model="registro.VL_PIS_ALIQUOTA_REAIS" :options="formatoMoeda"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
              </b-row>
              <hr class="my-4">
              <b-row>
                <b-col sm="6">
                  <label class="modal-label-premium">COFINS Situação Tributária</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_COFINS_SITUACAO_TRIBUTARIA" 
                        class="rounded-pill"
                        :options="cofins.opTipoSituacaoTributaria">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">COFINS Tipo Cálculo</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.OP_COFINS_TIPO_CALCULO" 
                        class="rounded-pill"
                        :options="cofins.opTipoCalculo">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Alíquota %</label>
                  <vue-autonumeric  v-model="registro.VL_COFINS_ALIQUOTA_PERCENT" :options="formatoPercentual"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Alíquota R$</label>
                  <vue-autonumeric  v-model="registro.VL_COFINS_ALIQUOTA_REAIS" :options="formatoMoeda"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true">
              <template #title>
                <i class='fa fa-hand-scissors-o mr-1'></i><strong> Beneficiamento</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="1">
                  <label class="modal-label-premium">Sexo</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.SEXO" 
                        class="rounded-pill"
                        :options="optionsSEXO">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Parte</label>
                  <b-form-select 
                        :plain="true" 
                        v-model="registro.PARTE" 
                        class="rounded-pill"
                        :options="optionsPARTE">
                  </b-form-select>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">% do Beneficiado:</label>
                  <vue-autonumeric  v-model="registro.PESO_POR_ANIMAL" :options="formatoPercentual"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Peças Por Animal:</label>
                  <vue-autonumeric  v-model="registro.PECAS_POR_ANIMAL" :options="formatoPecas"  class="form-control rounded-pill text-right"> </vue-autonumeric>
                </b-col>
                <b-col sm="5" class="text-right d-flex align-items-end justify-content-end">
                  <b-button 
                            variant="success"
                            pill
                            class="px-4 shadow-sm"
                            @click.stop="abrirModalBeneficiamento()"
                            ref="btAdicionarBeneficiamento"
                            v-b-popover.hover.left="'Incluir'"
                            type="button"> 
                        <i class="fa fa-plus mr-1"></i> Adicionar
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Lançamento "
                        stacked="md"
                        small
                        select-mode="single"
                        class="table-finance shadow-sm"
                        bordered
                        responsive
                        @row-clicked="abrirModalBeneficiamento"
                        :items="beneficiamento.items" 
                        :fields="beneficiamento.fields">
                        <template #cell(actions)="item" class="p-0">
                          <b-button 
                                    type="button"  
                                    size="sm" variant="soft-danger"  
                                    pill
                                    @click.stop="deleteBeneficiamento(item.item)"
                                    v-b-popover.hover.left="'Remover'">
                            <i class="fa fa-close"></i>
                          </b-button>
                        </template>
                    </b-table>
                </div>
              </b-row>
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true">
              <template #title>
                <i class='fa fa-cubes mr-1'></i><strong> Expedição</strong>
              </template>
              <b-row class="mt-2">
                <b-col sm="6">
                  <label class="modal-label-premium">Produto Retira Estoque na Expedição</label>
                  <produto-pesquisa 
                    @retornaId="registro.PRODUTO_RETIRA_ESTOQUE_ID = $event"
                    :idInicial="registro.PRODUTO_RETIRA_ESTOQUE_ID"
                    :desabilitarInput="false"
                    id-modal="modalProduto"
                    id="edPRODUTO_RETIRA_ESTOQUE"
                    ref="edPRODUTO_RETIRA_ESTOQUE"
                    :arredondado="true"
                    place="Pesquise o produto..."
                    labelBotao="">
                  </produto-pesquisa>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true">
              <template #title>
                <i class='fa fa-users mr-1'></i><strong> Id do Fornecedor</strong>
              </template>
              <b-row class="mt-2 align-items-end">
                <b-col sm="12" class="text-right d-flex align-items-end justify-content-end">
                  <b-button 
                            variant="success"
                            pill
                            class="px-4 shadow-sm"
                            @click.stop="abrirModalFornecedor()"
                            ref="btAdicionarFornecedor"
                            v-b-popover.hover.left="'Incluir'"
                            type="button"> 
                        <i class="fa fa-plus mr-1"></i> Adicionar
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Fornecedor Cadastrado"
                        stacked="md"
                        small
                        select-mode="single"
                        class="table-finance shadow-sm"
                        bordered
                        responsive
                        @row-clicked="abrirModalFornecedor"
                        :items="fornecedor.items" 
                        :fields="fornecedor.fields">
                        <template #cell(actions)="item" class="p-0">
                          <b-button 
                                    type="button"  
                                    size="sm" variant="soft-danger"  
                                    pill
                                    @click.stop="deleteFornecedor(item.item)"
                                    v-b-popover.hover.left="'Remover'">
                            <i class="fa fa-close"></i>
                          </b-button>
                        </template>
                    </b-table>
                </div>
              </b-row>
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true">
              <template #title>
                <i class='fa fa-tasks mr-1'></i><strong> Trilha de Auditoria</strong>
              </template>
              <b-row class="mt-2 align-items-end">
                <b-col sm="2">
                  <label class="modal-label-premium">Data Inicial</label>
                  <b-form-input type="date" id="dt1" ref="dt1" class="rounded-pill" v-model="trilha.dt1"/>
                </b-col>  
                <b-col sm="2">
                  <label class="modal-label-premium">Data Final</label>
                  <b-form-input type="date" id="dt2" ref="dt2" class="rounded-pill" v-model="trilha.dt2"/>
                </b-col>  
                <b-col sm="4">
                  <centro-estoque-pesquisa
                    @retornaId="trilha.centroEstoqueId = $event"
                    :idInicial="trilha.centroEstoqueId"
                    :classeRequired="true"
                    :desabilitarInput="false"
                    label="Centro Estoque"
                    id-modal="modalCentroEstoque"
                    id="edTrilhaCENTRO_ESTOQUE"
                    ref="edTrilhaCENTRO_ESTOQUE"
                    place=""
                    labelBotao="">
                  </centro-estoque-pesquisa>
                </b-col>  
                
                <b-col sm="4" class="d-flex justify-content-between align-items-center">
                    <b-button 
                          type="button" 
                          variant="primary" 
                          pill
                          class="px-4 shadow-sm"
                          @click.stop.prevent="listarTrilha()">
                        <i class="fa fa-search mr-1"></i> Listar
                    </b-button>
                    <b-pagination class="mb-0" :limit="2" :total-rows="trilha.items.length" per-page="20" v-model="trilha.currentPage" />
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Lançamento "
                        stacked="md"
                        small
                        select-mode="single"
                        class="table-finance shadow-sm"
                        bordered
                        per-page="20"
                        :current-page="trilha.currentPage"
                        responsive
                        :items="trilha.items" 
                        :fields="trilha.fields">
                    <template #cell(ENTRA_SAI)="item">
                      <b-badge pill :variant="colorirENTRA_SAI(item.item.ENTRA_SAI)" class="px-3 shadow-sm">{{traduzirENTRA_SAI(item.item.ENTRA_SAI)}}</b-badge>
                    </template>      
                    </b-table>
                </div>
              </b-row>
            </b-tab>
            
          </b-tabs>
        </b-card>
      </div>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL HISTORICO COMPRAS
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-historico-compras" 
          id="modal-historico-compras" 
          header-class="p-0"
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          modal-class="premium-modal"
          title="HISTORICO DE COMPRAS" >
        <template #modal-header>
          <div class="bg-gradient-primary w-100 p-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3">
                <i class="fa fa-history text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold text-white">Histórico de Compras</h5>
                <small class="text-white-50">{{ registro.CODIGO }} - {{ registro.DESCRICAO }}</small>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <b-pagination
                class="mb-0 mr-3"
                size="sm"
                :total-rows="historicoCompras.items.length"
                :per-page="historicoCompras.perPage"
                v-model="historicoCompras.currentPage"
              />
              <button type="button" class="close text-white" @click="$refs['modal-historico-compras'].hide()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </template>

        <b-card no-body class="border-0">
            <div class="p-0">
              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhuma compra localizada"
                stacked="md"
                small
                :per-page="historicoCompras.perPage"
                responsive 
                select-mode="single"
                class="table-finance mb-0"
                :current-page="historicoCompras.currentPage"
                :items="historicoCompras.items" 
                :fields="historicoCompras.fields">
                <template #cell(RAZAOSOCIAL)="row">
                  <div class="font-weight-bold text-dark">{{ row.item.RAZAOSOCIAL }}</div>
                  <small class="text-muted">ID: {{ row.item.FORNECEDOR_ID }}</small>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="light" pill class="px-4 font-weight-bold" @click="cancel()">
            FECHAR
          </b-button>
        </template>
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ATUALIZAR CUSTO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-custo" 
          id="modal-custo" 
          header-class="p-0"
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="lg"
          modal-class="premium-modal"
          title="ATUALIZAR CUSTO DO PRODUTO" >
        <template #modal-header>
          <div class="bg-gradient-info w-100 p-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3">
                <i class="fa fa-money text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold text-white">Atualizar Custo do Produto</h5>
                <small class="text-white-50">Ajuste manual de valores</small>
              </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-custo'].hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>

        <b-card no-body class="border-0">
            <div class="p-4">
              <div class="bg-light rounded p-3 mb-4 border-left border-info">
                <small class="text-muted d-block text-uppercase font-weight-bold mb-1">Produto Selecionado</small>
                <h6 class="mb-0 font-weight-bold text-dark">{{ registro.CODIGO }} - {{ registro.DESCRICAO }}</h6>
              </div>
              <b-row>
                <b-col sm="6">
                    <label class="modal-label-premium">Custo Atual</label>
                    <vue-autonumeric  v-model="registro.VL_CUSTO" :options="formatoMoeda" :disabled="true" class="form-control rounded-pill text-right bg-gray-100 border-0 font-weight-bold"> </vue-autonumeric>
                </b-col>
                <b-col sm="6">
                    <label class="modal-label-premium">Novo Custo</label>
                    <vue-autonumeric  v-model="modalCusto.custo" :options="formatoMoeda"  class="form-control rounded-pill text-right border-info font-weight-bold shadow-sm"> </vue-autonumeric>
                </b-col>
              </b-row>
            </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="light" pill class="px-4" @click="cancel()">
            CANCELAR
          </b-button>
          <b-button variant="info" pill class="px-4 shadow-sm font-weight-bold" @click="atualizarCusto()">
            <i class="fa fa-check mr-1"></i> ATUALIZAR CUSTO
          </b-button>
        </template>
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL BENEFICIAMENTO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-beneficiamento" 
          id="modal-beneficiamento" 
          header-class="p-0"
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="lg"
          modal-class="premium-modal" >
        <template #modal-header>
          <div class="bg-gradient-success w-100 p-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3">
                <i class="fa fa-plus-circle text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold text-white">Composição do Produto Principal</h5>
                <small class="text-white-50">Defina os itens que compõem este produto</small>
              </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-beneficiamento'].hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>

        <b-card no-body class="border-0">
          <div class="p-4">
            <b-row>
              <b-col sm="12">
                <label class="modal-label-premium">Produto Componente</label>
                <produto-pesquisa 
                  @retornaId="beneficiamento.registro.PRODUTO_ID = $event"
                  :idInicial="beneficiamento.registro.PRODUTO_ID"
                  :desabilitarInput="beneficiamento.itemAlteracao"
                  :classeRequired="!beneficiamento.registro.PRODUTO_ID"
                  id="edCOD_PRO"
                  ref="edCOD_PRO"
                  label=""
                  place="Pesquise o produto componente..."
                  labelBotao="">
                </produto-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="6">
                <label class="modal-label-premium">Quantidade de Peças</label>
                <vue-autonumeric   
                    :options="formatoMoeda"  
                    v-model="beneficiamento.registro.PECAS"
                    :class="['form-control rounded-pill text-right',
                                        {
                                          'is-invalid': beneficiamento.registro.PECAS == null || beneficiamento.registro.PECAS == 0,
                                          'is-valid': beneficiamento.registro.PECAS != null
                                        }
                                      ]"> 
                </vue-autonumeric>
                <small class="text-muted">Extraído do produto principal</small>
              </b-col>
              <b-col sm="6">
                <label class="modal-label-premium">Percentual (%)</label>
                <vue-autonumeric   
                  :options="formatoPercentual"  
                  v-model="beneficiamento.registro.PERCENTUAL"
                  :class="['form-control rounded-pill text-right',
                                        {
                                          'is-invalid': beneficiamento.registro.PERCENTUAL == null || beneficiamento.registro.PERCENTUAL == 0,
                                          'is-valid': beneficiamento.registro.PERCENTUAL != null
                                        }
                                      ]"> 
                </vue-autonumeric>
                <small class="text-muted">Equivalência no produto principal</small>
              </b-col>
            </b-row>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="light" pill class="px-4" @click="cancel()">
            CANCELAR
          </b-button>
          <b-button v-if="beneficiamento.emAlteracao" variant="success" pill class="px-4 shadow-sm font-weight-bold" @click.stop="editBeneficiamento()">
            <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÃO
          </b-button>
          <b-button v-else variant="success" pill class="px-4 shadow-sm font-weight-bold" @click.stop="postBeneficiamento()">
            <i class="fa fa-plus mr-1"></i> ADICIONAR ITEM
          </b-button>
        </template>
      </b-modal>
    </div>
    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL FORNECEDOR
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-fornecedor" 
          id="modal-fornecedor" 
          header-class="p-0"
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="lg"
          modal-class="premium-modal" >
        <template #modal-header>
          <div class="bg-gradient-info w-100 p-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3">
                <i class="fa fa-user text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold text-white">ID do Fornecedor</h5>
                <small class="text-white-50">Relaciona o código do fornecedor com o código interno</small>
              </div>
            </div>
            <button type="button" class="close text-white" @click="$refs['modal-fornecedor'].hide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>

        <b-card no-body class="border-0">
          <div class="p-4">
            <b-row>
              <b-col sm="12">
                <label class="modal-label-premium">Fornecedor</label>
                <cliente-pesquisa 
                  @retornaId="fornecedor.registro.FORNECEDOR_ID = $event"
                  :idInicial="fornecedor.registro.FORNECEDOR_ID"
                  :desabilitarInput="fornecedor.emAlteracao"
                  :classeRequired="!fornecedor.registro.FORNECEDOR_ID"
                  id="edFORNECEDOR"
                  ref="edFORNECEDOR"
                  label=""
                  place="Pesquise o fornecedor..."
                  labelBotao="">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col sm="6">
                <label class="modal-label-premium">Código do Produto do Fornecedor</label>
                <b-form-input 
                  type="text" 
                  id="edCODIGO_FORNECEDOR" 
                  ref="edCODIGO_FORNECEDOR"
                  class="rounded-pill" 
                  placeholder="Informe o código do fornecedor"
                  v-model="fornecedor.registro.CODIGO"
                  :state="!!fornecedor.registro.CODIGO"
                  maxlength="20">
                </b-form-input>
                <small class="text-muted">Código que o fornecedor usa para identificar este produto</small>
              </b-col>
            </b-row>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="light" pill class="px-4" @click="cancel()">
            CANCELAR
          </b-button>
          <b-button v-if="fornecedor.emAlteracao" variant="success" pill class="px-4 shadow-sm font-weight-bold" @click.stop="editFornecedor()">
            <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÃO
          </b-button>
          <b-button v-else variant="success" pill class="px-4 shadow-sm font-weight-bold" @click.stop="postFornecedor()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>
        </template>
      </b-modal>
    </div>
    

  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import TabelaPrecoPesquisa from '../../pesquisa/TabelaPrecoPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import GrupoProdutoDropDown from '../../componentes/dropdown/GrupoProdutoDropDown.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import {Money} from 'v-money'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import moment from 'moment'

export default {
  components: {
    VueButtonSpinner,
    HeaderPadrao,
    VendedorPesquisa,
    ClientePesquisa,
    TabelaPrecoPesquisa,
    GrupoProdutoDropDown,
    ProdutoPesquisa,
    CentroEstoquePesquisa,
    Money,
    axios,
    VueAxios,
    VueAutonumeric
  },
  data () {
    return {
      desabilitado: true,
      items: [],
      estados: [],
      municipios: [],
      municipiosBusy: false,
      isLoading: false,
      submmited: false,
      status: '',
      permiteAtualizarCredito: false,
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '0',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '3',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
        
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      historicoCompras: {
        nomeProduto: '',
        currentPage: 1,
        emAlteracao: false,
        perPage: 20,
        items: [],
        fields: [
          {
            key: "DT_CONFERENCIA_INICIO",
            label: 'Data', 
            sortable: true,
            thStyle: { width: "20%" },
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "RAZAOSOCIAL",
            label: 'Nome',
            thStyle: { width: "40%" }
          }
          ,
          {
            key: "QUANT_CONFERENCIA",
            label: 'Quant Confe',
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: "QT_PECAS",
            label: 'Unidades',
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0'
          },
          {
            key: 'VL_UNITARIO_FOB', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Preço',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'VL_TOTAL_FOB', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Total',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          }
        ]
      },
      modalCusto: {
        custo: 0
      },
      beneficiamento: {
        currentPage: 1,
        perPage: 5,
        emAlteracao: false,
        registro: {
          ID: null,
          PRODUTO_MESTRE_ID: null,
          PRODUTO_ID: null,
          PECAS: null,
          PERCENTUAL: null
        },
        items: [],
        fields: [
          {
            key: "PRODUTO_MESTRE_ID",
            label: 'Produto ID',
            thStyle: { width: "10%" }
          },
          {
            key: "DESCRICAO",
            label: 'Descrição',
            thStyle: { width: "65%" }
          },
          {
            key: "PECAS",
            label: 'Unidades',
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0'
          },
          {
            key: 'PERCENTUAL', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Percentual %',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: "actions",
            class:'align-middle text-center p-0',
            label: '',
            thStyle: { width: "5%" }
          }
        ]
      },
      fornecedor: {
        currentPage: 1,
        perPage: 10,
        emAlteracao: false,
        registro: {
          ID: null,
          PRODUTO_ID: null,
          FORNECEDOR_ID: null,
          CODIGO: null
        },
        items: [],
        fields: [
          {
            key: "FORNECEDOR_ID",
            label: 'Cód. Fornecedor',
            thStyle: { width: "15%" }
          },
          {
            key: "NOME",
            label: 'Nome Fornecedor',
            thStyle: { width: "55%" }
          },
          {
            key: "CODIGO",
            label: 'Código do Produto',
            thStyle: { width: "25%" }
          },
          {
            key: "actions",
            class:'align-middle text-center p-0',
            label: '',
            thStyle: { width: "5%" }
          }
        ]
      },
      trilha: {
        currentPage: 1,
        perPage: 10,
        dt1: Tools.getDataAtual(),
        dt2: Tools.getDataAtual(),
        items: [],
        fields: [
          {
            key: "ORDEM",
            label: '',
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" }
          },
          {
            key: "ENTRA_SAI",
            label: 'E/A',
            class:'align-middle text-center p-0',
            thStyle: { width: "10%" }
          },
          {
            key: "TIPO",
            label: 'Tipo',
            thStyle: { width: "25%" },
            class:'align-middle  p-0'
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente',
            thStyle: { width: "25%" }
          },
          {
            key: "DIA",
            label: 'Data', 
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0',
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "QUANT",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peso Kg/Quant',
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peças'
          }
        ]
      },
      
      optionsID_UNIDADE_COMERCIAL: [
        {value: null, text: 'Informe UND'}
      ],
      cep: {
        busy : false,
        submmited : false
      },
      optionsTRIBUTACAO_ICMS_INTERNA_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsTRIBUTACAO_ICMS_EXTERNA_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsTRIBUTACAO_ICMS_EXTERIOR_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsOP_TIPO_ESTOCAGEM: [
        { value: null, text: '' },
        { value: 'A', text: 'Ambiente' },
        { value: 'R', text: 'Resfriado' },
        { value: 'C', text: 'Congelado' },
      ],
      optionsFORMATO_EMBALAGEM_ID: [
        { value: null, text: '' }
      ],
      optionsETIQUETAS: [
        { value: null, text: '' }
      ],
      
      optionsOP_TIPO_DESCONTO: [
        { value: null, text: '' },
        { value: 'P', text: 'Percentual' },
        { value: 'V', text: 'Valor' }
      ],
      optionsCOR_ID: [
        { value: null, text: '' }
      ],
      optionsMATERIAL_ID: [
        { value: null, text: '' }
      ],
      optionsSEXO: [
        { value: null, text: '' },
        { value: 'M', text: 'Macho' },
        { value: 'F', text: 'Fêmea' }
      ],
      optionsPARTE: [
        { value: null, text: '' },
        { value: 'D', text: 'Dianteiro' },
        { value: 'T', text: 'Traseiro' },
        { value: 'M', text: 'Banda' },
        { value: 'P', text: 'Ponta de Agulha' },
        { value: 'S', text: 'Serrote' },
      ],
      pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        registro: {
          CODIGO                           : null,
          DESCRICAO                        : null,
          REZUMIDO                         : null,
          EAN                              : null,
          COD_FOR                          : null,
          COD_GRUP                         : null,
          UND_ENT                          : null,
          UND_SAI                          : null,
          UND_PECAS                        : null,
          VL_CUSTO                         : null,
          PECAS                            : null,
          MARGEM_FIL                       : null,
          MARGEM_CLI                       : null,
          VL_VENDA                         : null,
          SALDO_FI                         : null,
          SALDOFI_PECAS                    : null,
          SALDOFI_NOTA                     : null,
          SALDOPECAS_NOTA                  : null,
          EST_MAX                          : null,
          EST_MIN                          : null,
          GIRO_ENT                         : null,
          GIRO_SAI                         : null,
          MEMO1                            : null,
          MEMO2                            : null,
          MEMO3                            : null,
          DATALT                           : null,
          DT_ULTMOV                        : null,
          TRANSFERE                        : null,
          STATUS_VEN                       : null,
          STATUS_EST                       : null,
          VL_VENDAPRO                      : null,
          DT_INICIOPRO                     : null,
          DT_FIMPRO                        : null,
          VL_CLIENTE                       : null,
          MARGEM                           : null,
          COD_TIPO                         : null,
          CLASSEFISCAL                     : null,
          IPI                              : null,
          ISS                              : null,
          IRRF                             : null,
          COD_ARMAZENA                     : null,
          PESO                             : null,
          PROSERV                          : null,
          ST                               : null,
          QT_EMBALAGEM                     : null,
          EMBALAGEM                        : null,
          OP_BANDA_ABATE                   : null,
          ID_UNIDADE_COMERCIAL             : null,
          OP_IPI_SITUACAO_TRIBUTARIA       : null,
          OP_IPI_CLASS_ENQ_CIG_BEB         : null,
          TX_IPI_CODIGO_ENQUAD_LEGAL       : null,
          TX_IPI_CNPJ_PRODUTOR             : null,
          TX_IPI_NUM_SELO_CONTROLE         : null,
          OP_IPI_TIPO_CALCULO              : null,
          VL_IPI_ALIQUOTA                  : null,
          VL_IPI_QUANT_TOTAL_UND_PADRAO    : null,
          VL_IPI_UNIDADE                   : null,
          VL_IPI                           : null,
          OP_PIS_SITUACAO_TRIBUTARIA       : null,
          OP_PIS_TIPO_CALCULO              : null,
          VL_PIS_BASE_CALC                 : null,
          VL_PIS_ALIQUOTA_PERCENT          : null,
          VL_PIS_ALIQUOTA_REAIS            : null,
          VL_PIS_QUANT_VENDIDA             : null,
          VL_PIS                           : null,
          OP_PISST_TIPO_CALCULO            : null,
          VL_PISST_BASE_CALC               : null,
          VL_PISST_ALIQUOTA_PERCENT        : null,
          VL_PISST_ALIQUOTA_REAIS          : null,
          VL_PISST_QUANT_VENDIDA           : null,
          VL_PISST                         : null,
          OP_COFINS_SITUACAO_TRIBUTARIA    : null,
          OP_COFINS_TIPO_CALCULO           : null,
          VL_COFINS_BASE_CALC              : null,
          VL_COFINS_ALIQUOTA_PERCENT       : null,
          VL_COFINS_ALIQUOTA_REAIS         : null,
          VL_COFINS_QUANT_VENDIDA          : null,
          VL_COFINS                        : null,
          OP_COFINSST_TIPO_CALCULO         : null,
          VL_COFINSST_BASE_CALC            : null,
          VL_COFINSST_ALIQUOTA_PERCENT     : null,
          VL_COFINSST_ALIQUOTA_REAIS       : null,
          VL_COFINSST_QUANT_VENDIDA        : null,
          VL_COFINSST                      : null,
          TX_OBSERVACOES                   : null,
          VL_IPI_BASE_CALC                 : null,
          TX_NCM                           : null,
          ID_PRODUTO_SUBGRUPO              : null,
          PESO_LIQUIDO                     : null,
          TIPO_ID                          : null,
          CEST                             : null,
          VALIDADE                         : null,
          SEXO                             : null,
          OP_ANIMAL                        : null,
          TEXTO_BOTAO                      : null,
          PARTE                            : null,
          PERCENTUAL_DIANTEIRO             : null,
          PERCENTUAL_TRASEIRO              : null,
          PRODUTO_DIANTEIRO_ID             : null,
          PRODUTO_TRASEIRO_ID              : null,
          OP_PRODUTO_PRODUCAO              : null,
          VEICULO_ID                       : null,
          OP_SITUACAO                      : null,
          USUARIO_CADASTRO                 : null,
          USUARIO_ALTERACAO                : null,
          DT_CADASTRO                      : null,
          DT_ALTERACAO                     : null,
          OP_CUSTO_MANUAL                  : null,
          OP_BENEFICIA                     : null,
          OP_PERMITE_VENDA                 : null,
          OP_PAGA_COMISSAO                 : null,
          OP_PRECO_VARIAVEL                : null,
          OP_SERVICO                       : null,
          OP_GRADE                         : null,
          OP_USAR_TABELA_PRECO             : null,
          OP_COMBUSTIVEL                   : null,
          OP_MOSTRAR_APP                   : null,
          OP_BANDA                         : null,
          OP_QUARTO                        : null,
          OP_BENEFICIADO                   : null,
          OP_ALMOXARIFADO                  : null,
          OP_AUTOMOVEL                     : null,
          OP_MATERIA_PRIMA                 : null,
          OP_CONTROLA_LOTE                 : null,
          OP_USA_FORMULA                   : null,
          OP_GERA_LOTE_PRODUCAO            : null,
          VL_DESCONTO_PERCENTUAL           : null,
          VL_DESCONTO                      : null,
          OP_TIPO_DESCONTO                 : null,
          OP_PESADO                        : null,
          PRODUTO_COSTELA_ID               : null,
          CAPACIDADE                       : null,
          UNIDADE_COMERCIAL_CAPACIDADE_ID  : null,
          MATERIAL_ID                      : null,
          OP_EMBALAGEM                     : null,
          FORMATO_EMBALAGEM_ID             : null,
          COR_ID                           : null,
          CARBOIDRATOS                     : null,
          PROTEINAS                        : null,
          GORDURAS_TRANS                   : null,
          GORDURAS_SATURADAS               : null,
          GORDURAS_TOTAIS                  : null,
          COLESTEROL                       : null,
          FIBRA_ALIMENTAR                  : null,
          FERRO                            : null,
          SODIO                            : null,
          OBSERVACOES_NUTRICIONAIS         : null,
          QUANTIDADE_PORCAO                : null,
          VALOR_ENERGETICO                 : null,
          OP_ESTOQUE                       : null,
          TARA_EMBALAGEM                   : null,
          ETIQUETA_EXPEDICAO_ID            : null,
          ETIQUETA_INTERNA_ID              : null,
          ETIQUETA_DESOSSA_ID              : null,
          OP_PESO_FIXO                     : null,
          MENSAGEM_ARMAZENAMENTO           : null,
          MENSAGEM_CONSERVACAO             : null,
          OP_TIPO_ESTOCAGEM                : null,
          TEMPERATURA_MINIMA               : null,
          CARBOIDRATOS_PORCENTO            : null,
          PROTEINAS_PORCENTO               : null,
          GORDURAS_TRANS_PORCENTO          : null,
          GORDURAS_SATURADAS_PORCENTO      : null,
          GORDURAS_TOTAIS_PORCENTO         : null,
          COLESTEROL_PORCENTO              : null,
          FIBRA_ALIMENTAR_PORCENTO         : null,
          FERRO_PORCENTO                   : null,
          SODIO_PORCENTO                   : null,
          QUANTIDADE_PORCAO_PORCENTO       : null,
          VALOR_ENERGETICO_PORCENTO        : null,
          TEMPERATURA_MAXIMA               : null,
          ETIQUETA_BENEFICIAMENTO_ID       : null,
          ETIQUETA_RESUMO_ABATE_ID         : null,
          COD_SUBGRUPO                     : null,
          CODIGO_CENTROCUSTO               : null,
          CODIGO_SUBCENTROCUSTO            : null,
          DESCRI_GRUPO_CORTES              : null,
          CALCIO                           : null,
          CALCIO_PORCENTO                  : null,
          CARBOIDRATOS2                    : null,
          PROTEINAS2                       : null,
          GORDURAS_TRANS2                  : null,
          GORDURAS_SATURADAS2              : null,
          GORDURAS_TOTAIS2                 : null,
          COLESTEROL2                      : null,
          FIBRA_ALIMENTAR2                 : null,
          FERRO2                           : null,
          SODIO2                           : null,
          OBSERVACOES_NUTRICIONAIS2        : null,
          QUANTIDADE_PORCAO2               : null,
          VALOR_ENERGETICO2                : null,
          CALCIO2                          : null,
          CARBOIDRATOS_PORCENTO2           : null,
          PROTEINAS_PORCENTO2              : null,
          GORDURAS_TRANS_PORCENTO2         : null,
          GORDURAS_SATURADAS_PORCENTO2     : null,
          GORDURAS_TOTAIS_PORCENTO2        : null,
          COLESTEROL_PORCENTO2             : null,
          FIBRA_ALIMENTAR_PORCENTO2        : null,
          FERRO_PORCENTO2                  : null,
          SODIO_PORCENTO2                  : null,
          QUANTIDADE_PORCAO_PORCENTO2      : null,
          VALOR_ENERGETICO_PORCENTO2       : null,
          CALCIO_PORCENTO2                 : null,
          SIE                              : null,
          PECAS_POR_ANIMAL                 : null,
          PESO_POR_ANIMAL                  : null,
          EMBALAGEM_INTERNA_ID             : null,
          ETIQUETA_RECEPCAO_ID             : null,
          PRECO_MINIMO                     : null,
          OP_CONFIRMAR_PECAS_EXPEDICAO     : null,
          PRODUTO_RETIRA_ESTOQUE_ID        : null,
          OP_CONTROLA_PECAS                : null,
          ACUCARES_TOTAIS                  : null,
          ACUCARES_TOTAIS_PORCENTO         : null,
          ACUCARES_TOTAIS2                 : null,
          ACUCARES_TOTAIS_PORCENTO2        : null,
          ACUCARES_ADICIONADOS             : null,
          ACUCARES_ADICIONADOS_PORCENTO    : null,
          ACUCARES_ADICIONADOS2            : null,
          ACUCARES_ADICIONADOS_PORCENTO2   : null,
          TRIBUTACAO_ICMS_INTERNA_ID       : null,
          TRIBUTACAO_ICMS_EXTERNA_ID       : null,
          TRIBUTACAO_ICMS_EXTERIOR_ID      : null,
          ANO                              : null,
          NUMERO_INVENTARIO                : null,
          CLASSE                           : null,
          CODIGO_FABRICANTE                : null,
          CATEGORIA_ATIVO_ID               : null,
          EMPRESA_ID                       : null,
          OP_BEM_AGREGADO                  : null,
          DEPARTAMENTO_ID                  : null,
          OP_USO                           : null,
          OP_TIPO_BEM                      : null,
          DATA_IMPLANTACAO                 : null,
          DATA_AQUISICAO                   : null,
          VL_BEM                           : null,
          VL_DEPRECIACAO_ACUMULADO         : null,
          DATA_INICIO_DEPRECIACAO          : null,
        },
    }
  },
  
  methods: {
    async carregarUnidadeComercial() {

      try {
        const {data}  = await this.$http.get('/api/protected/unidadeComercial/getLista')
        
        for (const und of data ) {
          this.optionsID_UNIDADE_COMERCIAL.push({value: und.ID, text: und.ID})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar as unidades comerciais!')
        return
      }
    },

    async carregarTributacao() {
      try {
        const { data = [] } = await this.$http.get('/api/protected/tributacaoIcms/listar')

        this.optionsTRIBUTACAO_ICMS_INTERNA_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '1')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))

        this.optionsTRIBUTACAO_ICMS_EXTERNA_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '2')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))  

        this.optionsTRIBUTACAO_ICMS_EXTERIOR_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '3')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))  
        
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de Tributação do ICMS!')
        return
      }
    },
    async carregarFormatoEmbalagem() {
      try {
        const {data } = await this.$http.get('/api/protected/formatoEmbalagem/listar')
        for (const und of data ) {
          this.optionsFORMATO_EMBALAGEM_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Formatos de Embalagem!')
        return
      }
    },
    async carregarCores() {
      try {
        const {data } = await this.$http.get('/api/protected/cores/listar')
        for (const und of data ) {
          this.optionsCOR_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de cores!')
        return
      }
    },
    async carregarMateriais() {
      try {
        const {data } = await this.$http.get('/api/protected/materiais/listar')
        for (const und of data ) {
          this.optionsMATERIAL_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de materiais!')
        return
      }
    },
    async carregarEtiquetas() {
      try {
        const {data } = await this.$http.get('/api/protected/etiqueta/listar')
        for (const und of data ) {
          this.optionsETIQUETAS.push({value: und.ID, text: `${und.ID} - ${und.DESCRICAO}`})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de materiais!')
        return
      }
    },
    async carregarBeneficiamento() {
      try {
        const {data } = await this.$http.get(`/api/protected/produtoComposicao/getByProduto/${this.registro.CODIGO}`)
        this.beneficiamento.items = data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os cortes do beneficiamento!')
        return
      }
    },
    async abrirModalAtualizarCusto() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.modalCusto.custo = this.registro.VL_CUSTO
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-custo'].show()

      } catch(err) {
        this.$store.commit('controle/setAguardando', false)
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível!')
        return
      }
    },
    async atualizarCusto () {
      if ((this.modalCusto.custo == null) || (this.modalCusto.custo < 0)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o valor do custo!')
        return
      }
      
      try {
        

        const msg = await this.$bvModal.msgBoxConfirm('Atualizar o custo do produto?', {
          title: 'Sucesso',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        if (msg == false) return

        this.$store.commit('controle/setAguardando', true)  
        
        this.registro.VL_CUSTO = this.modalCusto.custo

        const editPayload = {
          produto: this.registro,
          login: window.localStorage.getItem('login'),
          operacao: 'alt'
        }
        await this.$http.post(`/api/protected/produto/edit`, editPayload)
        
        
        const custoPayload = {
          produto: this.registro,
          login: window.localStorage.getItem('login'),
          custo: this.modalCusto.custo
        }

        await this.$http.post(`/api/protected/produto/atualizarCusto`, custoPayload)

        let { data } = await this.$http.get(`/api/protected/produto/getById/${this.registro.CODIGO}`)
        this.registro = (data?.[0]) ?? {}

        this.$refs['modal-custo'].hide()
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Custo atualizado com sucesso' )

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados do Produto' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    async abrirModalHistoricoCompras() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const { data } = await this.$http.get(`/api/protected/produto/getHistoricoCompras/${this.registro.CODIGO}`)
        this.historicoCompras.items = data ?? []
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-historico-compras'].show()

      } catch(err) {
        this.$store.commit('controle/setAguardando', false)
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar as Compras!')
        return
      }
    },
    async abrirModalBeneficiamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        if (item) {
      
          const {data} = await this.$http.get(`/api/protected/produtoComposicao/getById/${item.ID}`)
          if (!data || !data.length) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o registro!')
            return  
          }  
          
          this.beneficiamento.registro = data[0]
          this.beneficiamento.emAlteracao = true
      
        } else {
          this.beneficiamento.emAlteracao = false

          this.beneficiamento.registro.ID = null
          this.beneficiamento.registro.PRODUTO_ID = null
          this.beneficiamento.registro.PRODUTO_MESTRE_ID = this.registro.CODIGO
          this.beneficiamento.registro.PECAS = 0
          this.beneficiamento.registro.PERCENTUAL = 0
        }

        this.$refs['modal-beneficiamento'].show()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async postBeneficiamento() {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/post`, this.beneficiamento.registro)
        await this.carregarBeneficiamento()
        this.$refs['modal-beneficiamento'].hide()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel gravar o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editBeneficiamento() {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/edit`, this.beneficiamento.registro)
        await this.carregarBeneficiamento()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel alterar os dados do registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async deleteBeneficiamento(item) {
      const msg = await this.$bvModal.msgBoxConfirm('Remover o produto do beneficiamento?', {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/delete`, {id: item.ID})
        await this.carregarBeneficiamento()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel alterar os dados do registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },

    async carregarFornecedor() {
      try {
        const {data } = await this.$http.get(`/api/protected/produtoFornecedor/getByProduto/${this.registro.CODIGO}`)
        this.fornecedor.items = data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os fornecedores do produto!')
        return
      }
    },

    async abrirModalFornecedor(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        if (item) {
      
          const {data} = await this.$http.get(`/api/protected/produtoFornecedor/getById/${item.ID}`)
          if (!data || !data.length) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível abrir o registro!')
            return  
          }  
          
          this.fornecedor.registro = data[0]
          this.fornecedor.emAlteracao = true
      
        } else {
          this.fornecedor.emAlteracao = false

          this.fornecedor.registro.ID = null
          this.fornecedor.registro.FORNECEDOR_ID = null
          this.fornecedor.registro.PRODUTO_ID = this.registro.CODIGO
          this.fornecedor.registro.CODIGO = null
        }

        this.$refs['modal-fornecedor'].show()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível abrir o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async postFornecedor() {
      if (!this.fornecedor.registro.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione o fornecedor!')
        return
      }
      
      if (!this.fornecedor.registro.CODIGO || this.fornecedor.registro.CODIGO.trim() === '') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o código do produto do fornecedor!')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        
        // Verificar duplicidade
        const verificacao = await this.$http.post(`/api/protected/produtoFornecedor/verificarDuplicidade`, {
          fornecedorId: this.fornecedor.registro.FORNECEDOR_ID,
          codigo: this.fornecedor.registro.CODIGO,
          produtoIdAtual: null
        })
        
        if (verificacao.data.existe) {
          Tools.exibirMensagem(
            this.$store, 
            'Aviso', 
            'warning', 
            `Já existe um produto com o mesmo código para esse fornecedor\n\nPRODUTO: ${verificacao.data.produto.CODIGO} - ${verificacao.data.produto.DESCRICAO}`
          )
          return
        }
        
        await this.$http.post(`/api/protected/produtoFornecedor/post`, this.fornecedor.registro)
        await this.carregarFornecedor()
        this.$refs['modal-fornecedor'].hide()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Fornecedor cadastrado com sucesso!')

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível gravar o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async editFornecedor() {
      if (!this.fornecedor.registro.FORNECEDOR_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione o fornecedor!')
        return
      }
      
      if (!this.fornecedor.registro.CODIGO || this.fornecedor.registro.CODIGO.trim() === '') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o código do produto do fornecedor!')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        
        // Verificar duplicidade (excluindo o produto atual)
        const verificacao = await this.$http.post(`/api/protected/produtoFornecedor/verificarDuplicidade`, {
          fornecedorId: this.fornecedor.registro.FORNECEDOR_ID,
          codigo: this.fornecedor.registro.CODIGO,
          produtoIdAtual: this.fornecedor.registro.PRODUTO_ID
        })
        
        if (verificacao.data.existe) {
          Tools.exibirMensagem(
            this.$store, 
            'Aviso', 
            'warning', 
            `Já existe um produto com o mesmo código para esse fornecedor\n\nPRODUTO: ${verificacao.data.produto.CODIGO} - ${verificacao.data.produto.DESCRICAO}`
          )
          return
        }
        
        await this.$http.post(`/api/protected/produtoFornecedor/edit`, this.fornecedor.registro)
        await this.carregarFornecedor()
        this.$refs['modal-fornecedor'].hide()
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Fornecedor atualizado com sucesso!')

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível alterar os dados do registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async deleteFornecedor(item) {
      const msg = await this.$bvModal.msgBoxConfirm('Remover o fornecedor do produto?', {
        title: 'Remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoFornecedor/delete`, {id: item.ID})
        await this.carregarFornecedor()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível excluir o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },

    async listarTrilha() {
      if (!this.trilha.centroEstoqueId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Centro de Estoque!')
        return
      }
      if (!this.trilha.dt1 || !this.trilha.dt2) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Período!')
        return
      }
      const payloadTrilha = {
        dt1: this.trilha.dt1,
        dt2: this.trilha.dt2,
        centroEstoqueId: this.trilha.centroEstoqueId,
        produtoId: this.registro.CODIGO
      }  
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const {data} = await this.$http.post(`/api/protected/estoque/listarTrilha`, payloadTrilha)
        this.trilha.items = data

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar a trilha do produto!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async atualizarListagemProdutos() {
      this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", this.registro.CODIGO || null)
      await this.$store.dispatch('produto/GET_LISTA', { skipConfirmation: true })
    },
    async voltar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.atualizarListagemProdutos()
      } catch (err) {
        console.log(err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$router.push('/cadastros/produto/index')
      }
    },
    normalizarFlagsFormula() {
      this.registro.OP_MATERIA_PRIMA = String(this.registro.OP_MATERIA_PRIMA ?? '0').trim() === '1' ? '1' : '0'
      this.registro.OP_CONTROLA_LOTE = String(this.registro.OP_CONTROLA_LOTE ?? '0').trim() === '1' ? '1' : '0'
      this.registro.OP_USA_FORMULA = String(this.registro.OP_USA_FORMULA ?? '0').trim() === '1' ? '1' : '0'
      this.registro.OP_GERA_LOTE_PRODUCAO = String(this.registro.OP_GERA_LOTE_PRODUCAO ?? '0').trim() === '1' ? '1' : '0'
    },
    onHidden_botaoGerarCEP() {
      // Return focus to the button
      if (this.registro.ENDERECO) {
        this.$refs.edNumero.focus()
      }
    },
    async postOrEdit () {
      if (this.avisos()) return
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.CODIGO) {
          
          try {  
            const postPayload = {
              produto: this.registro,
              login: window.localStorage.getItem('login')
            }

            const { data } = await this.$http.post(`/api/protected/produto/post`, postPayload)
            
            if (!data || !data.produto) {
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível cadastrar o Produto!' )  
              return
            }
            
            this.registro = data.produto
            
            
            this.$store.commit("produto/SET_LIMPAR", null)
            this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", this.registro.CODIGO)
            this.$store.commit("produto/SET_ID", this.registro.CODIGO)
            this.$store.commit('produto/SET_PAGINA_ATUAL', 1)
            await this.$store.dispatch('produto/GET_LISTA')
            this.$store.commit("produto/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 

            this.$store.commit('controle/setAguardando', false)  

            const msg = await this.$bvModal.msgBoxConfirm('Produto cadastrado com Sucesso. Continuar Cadastrando?', {
              title: 'Sucesso',
              size: 'sm',
              buttonSize: 'xl',
              okVariant: 'success',
              okTitle: 'SIM',
              cancelTitle: 'NÃO',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true,
              noCloseOnEsc: true, 
              noCloseOnBackdrop: true
            })
            
            if (msg == true) return

            this.$router.push('/cadastros/produto/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados do Produto' )
            return
          }

        } else {

          if (this.registro.CODIGO == this.registro.PRODUTO_RETIRA_ESTOQUE_ID) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! O Produto não pode ser vinculado a ele mesmo no campo "Produto Retira Estoque".' )
            return
          }

          try {        
            const editPayload = {
              produto: this.registro,
              login: window.localStorage.getItem('login'),
              operacao: this.emAlteracao == true ? 'alt' : 'inc' //necessario para o backend entender se o form inicio como novo ou iniciou como edicao
            }
            let { data } = await this.$http.post(`/api/protected/produto/edit`, editPayload)
            this.registro = (data?.produto) ?? null

            await this.atualizarListagemProdutos()

            this.$store.commit('controle/setAguardando', false)  

            this.$router.push('/cadastros/produto/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados do Produto' )
            return
          }

          
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    async getEstados () {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
        await this.getMunicipios()
      } catch(err) {
        this.estados = []
      }
    },
    async getMunicipios () {
      this.municipiosBusy = true
      
      this.municipios = []
      this.municipiosBusy = false
      
      if (this.registro.ID_UF) {
        try {
          let result = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios = result.data
          this.municipiosBusy = false
        } catch(err) {
          this.municipiosBusy = false
        }
      }
      
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)  

      this.registro.CODIGO = null
      this.registro.OP_PISST_TIPO_CALCULO = null
      this.registro.OP_PIS_TIPO_CALCULO = null
      this.registro.OP_PIS_SITUACAO_TRIBUTARIA = null
      this.registro.PROSERV = 'P'
      this.registro.STATUS_EST = 'ATIVO'
      this.registro.STATUS_VEN = 'ATIVO'
      this.registro.OP_SITUACAO = '1'
      this.registro.OP_PERMITE_VENDA = '1'
      this.registro.OP_PAGA_COMISSAO = '1';
      this.registro.OP_PRECO_VARIAVEL = null
      this.registro.OP_SERVICO = null
      this.registro.OP_GRADE = null
      this.registro.OP_USAR_TABELA_PRECO = null
      this.registro.OP_COMBUSTIVEL = null
      this.registro.OP_MOSTRAR_APP = '1';
      this.registro.OP_BANDA = null
      this.registro.OP_QUARTO = null
      this.registro.OP_BENEFICIADO = null
      this.registro.OP_ALMOXARIFADO = null
      this.registro.VL_DESCONTO_PERCENTUAL = 0.00
      this.registro.VL_DESCONTO = 0.00
      this.registro.OP_TIPO_DESCONTO = null,
      this.registro.OP_AUTOMOVEL = null
      this.registro.OP_MATERIA_PRIMA = '0'
      this.registro.OP_CONTROLA_LOTE = '0'
      this.registro.OP_USA_FORMULA = '0'
      this.registro.OP_GERA_LOTE_PRODUCAO = '0'
      this.registro.OP_PESADO = null
      this.registro.OP_EMBALAGEM = null
      this.registro.OP_ESTOQUE = '1'
      this.registro.OP_PESO_FIXO = null
      this.normalizarFlagsFormula()
      
    },
    
    validarCNPJ(c) {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      if ((c = c.replace(/[^\d]/g, "")).length != 14)
          return false

      if (/0{14}/.test(c))
          return false

      for (var j = 0; j < 2; ++j) {
          for (var i = 0, n = 0; i < 12 + j; n += c[i] * b[++i - j])
          if (c[12 + j] != ((n %= 11) < 2) ? 0 : 11 - n)
              return false;
      }

      return true
    },
    avisos() {
      if (!this.registro.DESCRICAO) {
        this.$refs.edDESCRICAO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome do Produto')
        return true
      }
      else if (!this.registro.REZUMIDO) {
        this.$refs.edREZUMIDO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome Rezumido')
        return true
      }
      else if (!this.registro.ID_UNIDADE_COMERCIAL) {
        this.$refs.comboID_UNIDADE_COMERCIAL.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Unidade Comercializada')
        return true
      }
      else if (!this.registro.TX_NCM) {
        this.$refs.edTX_NCM.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a NCM do Produto')
        return true
      }
      else if ((!this.registro.PESO) || (this.registro.PESO <= 0) ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Peso Bruto do Produto (Necessário para Nfe)')
        return true
      }
      else if ((!this.registro.PESO_LIQUIDO) || (this.registro.PESO_LIQUIDO < 0) ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Peso da Embalagem Produto (Necessário para Nfe)')
        return true
      }
      
      return false
      
    },
    traduzirENTRA_SAI(valor) {
      switch (valor) {
        case 'E':
          return 'Entrada'
        case 'S':
          return 'Saida'
        default:
          return ''
      }
    },
    colorirENTRA_SAI(valor) {
      switch (valor) {
        case 'E':
          return 'success'
        case 'S':
          return 'danger'
        default:
          return ''
      }
    }
    
  },
  computed: {
    habilitaGruposFilhos() {
      return this.registro.CODIGO != null && this.registro.CODIGO > 0
    },
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null

    try {
      this.$store.commit('controle/setAguardando', true)  
      const loaders = [
        this.carregarUnidadeComercial(),
        this.carregarTributacao(),
        this.carregarFormatoEmbalagem(),
        this.carregarCores(),
        this.carregarMateriais(),
        this.carregarEtiquetas(),
      ]

      await Promise.all(loaders)

      
      if ( id ) {
        

        this.emAlteracao = true
        const { data: result } = await this.$http.get(`/api/protected/produto/getById/${id}`)
        if (!Array.isArray(result) || result.length === 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
          this.$router.replace('/cadastros/produto/index')
          return
        }
        
        this.registro = { ...result[0] }
        this.normalizarFlagsFormula()

        await this.carregarBeneficiamento()
        await this.carregarFornecedor()

      } else {
        this.emAlteracao = false
        await this.limparRegistro()
      }
    } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.replace('/cadastros/produto/index') 
    } finally {
      this.$store.commit('controle/setAguardando', false)  
    }
  },
  mounted (){
    this.$nextTick(() => {
      if (!this.$route.params.id) {
        // tenta API do componente; se não, foca no input interno
        const c = this.$refs.edDESCRICAO
        if (c?.focus) c.focus()
        else c?.$el?.querySelector('input')?.focus()
      }
    })
  },
  watch: {
    'registro.FORMA_PAGAMENTO': async function (val, oldVal) {
      if (!oldVal && val) {
        return
      }


      if (val === 'V') {
       this.registro.DIAS_INICIAR_PAGAMENTO = 0 
       this.registro.PRAZO = 0 
       this.registro.DIAS_ENTRE_PARCELAS = 0
      }
    },
    'registro.ID_UF': async function () {
      await this.getMunicipios()
    },
    'registro.FIZ_JUR': function () {
      if (this.registro.FIZ_JUR == '0' ) { //Fisica
        this.registro.RAZAOSOCIAL =  this.registro.NOME
      }
      else if (this.registro.FIZ_JUR == '2' ) { //Exterior
        this.registro.INS_EST = null
        this.registro.INS_SUFRAMA = null
      }

    }
  }
}
</script>
<style lang="css" scoped>
.prepend-160 {
  flex: 0 0 130px;   /* fixa a coluna */
  width: 130px;      /* redundante, mas ajuda em alguns temas */
  min-width: 130px;  /* garante que não encolha */
}

/* --- PREMIUM UI FIXES --- */
.bg-black-25 {
  background-color: rgba(0, 0, 0, 0.25) !important;
}
.bg-white-20 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.bg-gradient-primary {
  background: linear-gradient(87deg, #2196f3 0, #21cbf3 100%) !important;
}
.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}
.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.modal-label-premium {
  font-size: 0.7rem;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.4rem;
  display: block;
}

/* --- TABLE FINANCE --- */
.table-finance thead th {
  background-color: #f8f9fa !important;
  color: #4a5568 !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  font-size: 0.75rem !important;
  border-top: none !important;
  border-bottom: 2px solid #edf2f7 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568 !important;
  border-bottom: 1px solid #edf2f7 !important;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

/* Ajuste para os modais não ficarem "opacos" ou sem contraste */
::v-deep .premium-modal .modal-content {
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17) !important;
}

::v-deep .premium-modal .modal-body {
  padding: 0 !important;
}

.white-10 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
</style>




// WEBPACK FOOTER //
// src/views/cadastros/produtos/ProdutosCadastro.vue